import { getAuthToken } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data.message || data.error || `HTTP ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};

// ── API Catalog ───────────────────────────────────────────────────────────────

export const getApis = () =>
  makeRequest(`${API_BASE_URL}/api/health-check/apis`);

export const createApi = (name) =>
  makeRequest(`${API_BASE_URL}/api/health-check/apis`, {
    method: 'POST',
    body: JSON.stringify({ name }),
  });

export const deleteApi = (id) =>
  makeRequest(`${API_BASE_URL}/api/health-check/apis/${id}`, { method: 'DELETE' });

// ── Tenants / Environments ────────────────────────────────────────────────────

export const getTenants = () =>
  makeRequest(`${API_BASE_URL}/api/health-check/tenants`);

/**
 * @param {{ name: string, tenantApis: Array<{ apiId: number, url: string }> }} payload
 */
export const createTenant = (payload) =>
  makeRequest(`${API_BASE_URL}/api/health-check/tenants`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

/**
 * @param {number} id
 * @param {{ name: string, tenantApis: Array<{ apiId: number, url: string }> }} payload
 */
export const updateTenant = (id, payload) =>
  makeRequest(`${API_BASE_URL}/api/health-check/tenants/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const deleteTenant = (id) =>
  makeRequest(`${API_BASE_URL}/api/health-check/tenants/${id}`, { method: 'DELETE' });

// ── Probe ─────────────────────────────────────────────────────────────────────

/**
 * Backend proxies a GET to the given URL and returns the parsed /info response.
 * Always resolves (never throws) — check result.success.
 * @param {string} url
 * @returns {Promise<{ success: boolean, data: object|null, error: string|null }>}
 */
export const probe = (url) =>
  makeRequest(`${API_BASE_URL}/api/health-check/probe`, {
    method: 'POST',
    body: JSON.stringify({ url }),
  });
